module.exports = __webpack_public_path__ + "static/media/SohoGothicProMedium.99bab41f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SohoGothicProMedium.woff2
// module id = 838
// module chunks = 0